import React from 'react';  
import styled, { createGlobalStyle } from 'styled-components';  
import qrCodeImage from './images/qr_code.png'; // 画像ファイルをインポート  
  
const GlobalStyle = createGlobalStyle`  
  body, html {  
    margin: 0;  
    padding: 0;  
    height: 100%;  
    background: #fafafa;  
  }  
`;  
  
const Container = styled.div`  
  font-family: Arial, sans-serif;  
  padding: 20px;  
  display: flex;  
  flex-direction: column;  
  align-items: center;  
  height: 100%; /* 高さを100%に設定 */  
  color: #FFFFFF;  
`;  
  
const Header = styled.div`  
  display: flex;  
  flex-direction: column;  
  align-items: center;  
  margin-top: 20px;  
`;  
  
const Image = styled.img`  
  width: 200px;  
  height: 200px;  
  object-fit: contain;  
  border-radius: 5px;  
  margin-top: 20px;  
`;  
  
const QrCode = () => (  
  <>  
    <GlobalStyle />  
    <Container>  
      <Header>  
        <h2 style={{ fontSize: '24px', fontWeight: 'bold' }}>  
          QRコードでURLを共有  
        </h2>  
        <Image src={qrCodeImage} alt="QR Code" />  
      </Header>  
    </Container>  
  </>  
);  
  
export default QrCode;  
